import React, { useEffect, useState } from "react";
import { Nav, Button, Offcanvas, Modal } from "react-bootstrap";
import "../styles/Dashboard.css";
import { NavLink } from "react-router-dom";
import Notification from "../pages/Notification";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { rewardService } from "../services";
import { notificationService } from "../services";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [content, setContent] = useState([]);
  const [unread, setUnread] = useState([]);

  // Log Out Function
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    getContentList();
    getNotificationList();
  }, []);

  //****** Fetch contentList ******
  const getContentList = async () => {
    try {
      const res = await rewardService.getContentList();
      if (res && res.data) {
        setContent(res.data);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  const getNotificationList = async () => {
    try {
      const payload = {
        pageNumber: 1,
        pageSize: 10,
      };
      const res = await notificationService.getNotification(payload);
      if (res && res.data) {
        const list = res.data.notificationList;
        const listCount = list.filter((n) => !n.isRead).length;
        setUnread(listCount);
      }
    } catch (error) {
      console.log("Error fetching notifications list");
    }
  };

  return (
    <>
      <Modal
        className="modelpopup222 mobile-noti"
        show={showNotificationModal}
        onHide={() => setShowNotificationModal(false)}
        centered
        dialogClassName="notificationModalWrapper"
      >
        <div className="popupall">
          <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
          <Modal.Body className="p-0">
            <Notification />
          </Modal.Body>
        </div>
      </Modal>

      {/* Sidebar for Large Screens */}
      <div
        className={`sidebar d-none d-lg-flex flex-column  text-white p-3 ${
          isOpen ? "open" : "closed"
        }`}
      >
        <div className="sidebar-logo text-center">
          <img
            src="/images/mainLogo.png"
            alt="Logo"
            // style={{ width: isOpen ? "150px" : "50px", transition: "0.3s" }}
          />
        </div>
        <Nav className="side-menue1" style={{ gap: "25px" }}>
          <NavLink
            to="/"
            className={({ isActive }) =>
              `nav-linkMain custom-nav ${isActive ? "active-link" : ""}`
            }
          >
            <img
              src="/images/home.png"
              alt="Home"
              className="custom-icon imageicon-defult"
            />
            <img
              src="/images/homeWhite.png"
              alt="Rewards"
              className="custom-icon imageicon-select"
            />
            <span> HOME </span>
          </NavLink>
          <NavLink
            to="/rewardsPage"
            className={({ isActive }) =>
              `nav-linkMain custom-nav ${isActive ? "active-link" : ""}`
            }
          >
            <img
              src="/images/star.png"
              alt="Rewards"
              className="custom-icon imageicon-defult"
            />
            <img
              className="custom-icon imageicon-select"
              src="/images/starWhite.png"
              alt="Rewards"
            />
            {/* REWARDS */}
            REDEEM
          </NavLink>
          <NavLink
            to="/profile"
            className={({ isActive }) =>
              `nav-linkMain custom-nav ${isActive ? "active-link" : ""}`
            }
          >
            <img
              src="/images/user.png"
              alt="Profile"
              className="custom-icon imageicon-defult"
            />
            <img
              src="/images/userWhite.png"
              alt="Rewards"
              className="custom-icon imageicon-select"
            />
            PROFILE
          </NavLink>
        </Nav>

        <Button
          className="side-nav-bt12"
          onClick={() =>
            window.open(
              "https://evolvcollection.com/#book",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          BOOK A TABLE
        </Button>

        <ul className="nav flex-column benefits-list1">
          {content?.map((item) => (
            <li className="nav-item" key={item.id}>
              <a
                className="nav-link"
                style={{ fontSize: "11px", color: "#FD948D" }}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.title}
              </a>
            </li>
          ))}

          {/* Static logout option */}
          <li className="nav-item">
            <a
              className="nav-link"
              style={{ fontSize: "11px", color: "#FD948D", cursor: "pointer" }}
              onClick={handleLogout}
            >
              Log Out
            </a>
          </li>
        </ul>

        <div className="app-links text-center playstore">
          <img
            src="\images\appStore_GglPlay.png"
            alt="App Store"
            className="store-icon"
          />
          {/* <img src="/images/playstore.png" alt="Google Play" className="store-icon" /> */}
        </div>
        <a
          href="https://theloyaltyco.app"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <p
            className="powered-text text-start power1"
            style={{ fontSize: "11px", color: "#FD948D" }}
          >
            Powered by TLC
          </p>
        </a>
      </div>

      {/* Navbar for Small Screens */}
      <div
        className="d-lg-none fixed-top  d-flex justify-content-between align-items-center p-3 w-100"
        style={{ zIndex: 1050, backgroundColor: "#2F0742" }}
      >
        <img src="/images/mainLogo.png" alt="Logo" style={{ width: "120px" }} />

        <div className="notificationBell">
          <img
            src="/images/notification.png"
            alt="Logo"
            onClick={() => setShowNotificationModal(true)}
            style={{ cursor: "pointer" }}
          />
          {unread > 0 && <span className="notif-dot1" />}
          <Button
            variant="outline-light"
            onClick={handleShow}
            style={{ paddingRight: "2px" }}
          >
            ☰
          </Button>
        </div>
      </div>

      {/* Offcanvas Menu */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className=" w-50"
        style={{ zIndex: 1100, backgroundColor: "#2F0742" }}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>
            <img
              src="/images/mainLogo.png"
              alt="Logo"
              style={{ width: "150px" }}
            />
          </Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="text-start">
          <Nav className="side-menue1" style={{ gap: "25px" }}>
            <NavLink
              as={NavLink}
              to="/"
              className={({ isActive }) =>
                `nav-linkMain custom-nav ${isActive ? "active-link" : ""}`
              }
            >
              <img
                src="/images/home.png"
                alt="Home"
                className="custom-icon imageicon-defult"
              />
              <img
                className="custom-icon imageicon-select"
                src="/images/homeWhite.png"
                alt="Rewards"
              />
              HOME
            </NavLink>
            <NavLink
              as={NavLink}
              to="/rewardsPage"
              className={({ isActive }) =>
                `nav-linkMain custom-nav ${isActive ? "active-link" : ""}`
              }
            >
              <img
                src="/images/star.png"
                alt="Rewards"
                className="custom-icon imageicon-defult"
              />
              <img
                src="/images/starWhite.png"
                alt="Rewards"
                className="custom-icon imageicon-select"
              />
              REWARDS
            </NavLink>
            <NavLink
              as={NavLink}
              to="/profile"
              className={({ isActive }) =>
                `nav-linkMain custom-nav ${isActive ? "active-link" : ""}`
              }
            >
              <img
                src="/images/user.png"
                alt="Profile"
                className="custom-icon imageicon-defult"
              />
              <img
                src="/images/userWhite.png"
                alt="Rewards"
                className="custom-icon imageicon-select"
              />
              PROFILE
            </NavLink>

            <Button
              className="side-nav-bt12"
              onClick={() =>
                window.open(
                  "https://www.danddlondon.com/restaurants/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              BOOK A TABLE
            </Button>

            <ul className="nav flex-column benefits-list1">
              {content
                ?.filter((item) => item.isActive)
                .map((item) => (
                  <li className="nav-item" key={item.id}>
                    <a
                      className="nav-link p-0 pb-1"
                      style={{ fontSize: "11px", color: "#FD948D" }}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.title}
                    </a>
                  </li>
                ))}

              {/* Static Logout Button */}
              <li className="nav-item">
                <a
                  className="nav-link p-0 pb-1"
                  style={{
                    fontSize: "11px",
                    color: "#FD948D",
                    cursor: "pointer",
                  }}
                  onClick={handleLogout}
                >
                  Log Out
                </a>
              </li>
            </ul>

            <div className="app-links mt-4 text-center">
              <img
                src="\images\appStore_GglPlay.png"
                alt="App Store"
                className="store-icon"
              />
            </div>
            <a
              href="https://theloyaltyco.app"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <p style={{ fontSize: "11px", color: "#FD948D" }}>
                Powered by TLC
              </p>
            </a>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
